var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { slot: "operations" }, slot: "operations" },
    [
      _vm.pageMode === 1
        ? _c(
            "div",
            {
              staticStyle: {
                display: "inline-block",
                "font-size": "14px",
                color: "orangered"
              }
            },
            [
              _c(
                "span",
                {
                  staticStyle: { "padding-right": "15px", "font-size": "14px" }
                },
                [_vm._v(_vm._s(_vm.buildTitle()))]
              )
            ]
          )
        : _vm._e(),
      _vm.pageMode === 1
        ? _c(
            "el-button",
            {
              attrs: { type: "primary", no: "1" },
              on: {
                click: function($event) {
                  return _vm.$emit("toChangePage")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("WriteOff.return")))]
          )
        : _vm._e(),
      _vm.pageMode === 1
        ? _c(
            "el-button",
            {
              attrs: { type: "primary", no: "2" },
              on: {
                click: function($event) {
                  return _vm.$emit("toHedgeWriteOff")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("WriteOff.confirm")))]
          )
        : _vm._e(),
      _vm.pageMode !== 1 && _vm.hasPermission()
        ? _c(
            "el-button",
            {
              attrs: { type: "primary", no: "3" },
              on: {
                click: function($event) {
                  return _vm.$emit("toWriteOff")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("WriteOff.writeOffs")))]
          )
        : _vm._e(),
      _vm.pageMode !== 1 && _vm.hasPermission()
        ? _c(
            "el-button",
            {
              attrs: { type: "primary", no: "4" },
              on: {
                click: function($event) {
                  return _vm.$emit("toChangePage")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("WriteOff.hedgingWriteOffs")))]
          )
        : _vm._e(),
      _vm.pageMode !== 1
        ? _c(
            "el-button",
            {
              attrs: { type: "primary", no: "5" },
              on: {
                click: function($event) {
                  return _vm.$emit("toActualPayment")
                }
              }
            },
            [_vm._v(_vm._s(_vm.$t("WriteOff.actualReceiptAndPayment")))]
          )
        : _vm._e(),
      _vm.pageMode !== 1 && (_vm.role.ar || _vm.role.ap)
        ? _c(
            "el-dropdown",
            {
              staticClass: "el-dropdown-spacing",
              attrs: { no: "13", "split-button": "", type: "primary" },
              on: {
                click: function($event) {
                  return _vm.exportHandle()
                },
                command: function(p) {
                  _vm.exportCommand = p
                  _vm.exportHandle()
                }
              }
            },
            [
              [
                _vm.$t("CargoMsg.Cargo_BatchImportAr2"),
                _vm.$t("CargoMsg.Cargo_BatchImportAp2")
              ].includes(_vm.exportCommand)
                ? _c("span", [_vm._v(_vm._s(_vm.exportCommand))])
                : _vm._e(),
              [
                _vm.$t("CargoMsg.Cargo_BatchImportAr1"),
                _vm.$t("CargoMsg.Cargo_BatchImportAp1")
              ].includes(_vm.exportCommand)
                ? _c(
                    "el-upload",
                    {
                      staticStyle: {
                        display: "inline-block",
                        "margin-left": "5px"
                      },
                      attrs: {
                        action: _vm.URL.act.actualAmount.batchImportWriteOffUrl,
                        headers: _vm.headers,
                        "show-file-list": false,
                        accept: ".xls, .xlsx",
                        "before-upload": _vm.beforeOrderUpload,
                        "on-success": _vm.uploadOrderSuccess,
                        "on-error": _vm.handleError,
                        data: {
                          branchId: _vm.$store.getters.currentOfficeId,
                          type: 1
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "white" } }, [
                        _vm._v(_vm._s(_vm.exportCommand))
                      ])
                    ]
                  )
                : _vm._e(),
              _c(
                "el-dropdown-menu",
                { attrs: { slot: "dropdown" }, slot: "dropdown" },
                [
                  [-1, 1].includes(_vm.searchConditions.isAr) && _vm.role.ar
                    ? _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: _vm.$t("CargoMsg.Cargo_BatchImportAr1")
                          }
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "batchImportAr",
                              staticStyle: { display: "inline-block" },
                              attrs: {
                                action:
                                  _vm.URL.act.actualAmount
                                    .batchImportWriteOffUrl,
                                headers: _vm.headers,
                                "show-file-list": false,
                                accept: ".xls, .xlsx",
                                "before-upload": _vm.beforeOrderUpload,
                                "on-success": _vm.uploadOrderSuccess,
                                "on-error": _vm.handleError,
                                data: {
                                  branchId: _vm.$store.getters.currentOfficeId,
                                  type: 1
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_BatchImportAr1")
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  [-1, 0].includes(_vm.searchConditions.isAr) && _vm.role.ap
                    ? _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: _vm.$t("CargoMsg.Cargo_BatchImportAp1")
                          }
                        },
                        [
                          _c(
                            "el-upload",
                            {
                              ref: "batchImportAp",
                              staticStyle: { display: "inline-block" },
                              attrs: {
                                action:
                                  _vm.URL.act.actualAmount
                                    .batchImportWriteOffUrl,
                                headers: _vm.headers,
                                "show-file-list": false,
                                accept: ".xls, .xlsx",
                                "before-upload": _vm.beforeOrderUpload,
                                "on-success": _vm.uploadOrderSuccess,
                                "on-error": _vm.handleError,
                                data: {
                                  branchId: _vm.$store.getters.currentOfficeId,
                                  type: 0
                                }
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("CargoMsg.Cargo_BatchImportAp1")
                                  )
                                )
                              ])
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  [-1, 1].includes(_vm.searchConditions.isAr) && _vm.role.ar
                    ? _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: _vm.$t("CargoMsg.Cargo_BatchImportAr2")
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_BatchImportAr2"))
                          )
                        ]
                      )
                    : _vm._e(),
                  [-1, 0].includes(_vm.searchConditions.isAr) && _vm.role.ap
                    ? _c(
                        "el-dropdown-item",
                        {
                          attrs: {
                            command: _vm.$t("CargoMsg.Cargo_BatchImportAp2")
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_BatchImportAp2"))
                          )
                        ]
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.searchConditions.writeOffMode === 2
        ? _c(
            "el-button",
            {
              staticStyle: { "margin-left": "5px" },
              attrs: { type: "primary" },
              on: { click: _vm.autoReceivablesWriteOff }
            },
            [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_AutoReceivablesWriteOff")))]
          )
        : _vm._e(),
      _vm.fileUploadSuccessDialog.visible
        ? _c("file-upload-success-dialog", {
            ref: "fileUploadSuccessDialog",
            attrs: {
              visible: _vm.fileUploadSuccessDialog.visible,
              code: _vm.fileUploadSuccessDialog.code
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.fileUploadSuccessDialog, "visible", $event)
              },
              cancelCallback: function($event) {
                _vm.fileUploadSuccessDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.checkingSaveJobWindow.visible
        ? _c("checking-save-job-window", {
            attrs: {
              visible: _vm.checkingSaveJobWindow.visible,
              lob: _vm.checkingSaveJobWindow.lob,
              "row-data": _vm.checkingSaveJobWindow.rowData,
              "check-node": _vm.checkingSaveJobWindow.checkNode,
              "call-back": _vm.checkingSaveJobWindow.callBack
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(_vm.checkingSaveJobWindow, "visible", $event)
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }